export const adminEn = {
  "Sr": "Sr",
  "Business Name": "Business Name",
  "Mail": "Mail",
  "Phone": "Phone",
  "Address": "Address",
  "BN Number": "BN Number",
  "Total Tons": "Total Tons",
  "Recent Activity": "Recent Activity",
  "Name": "Name",
  "Email": "Email",
  "Active": "Active",
  "Job Title": "Job Title",
  "Business name": "Business name",
  "Created Date": "Created Date",
  "Number Of Orders": "Number Of Orders",
  "Date": "Date",
  "Supplier name": "Supplier name",
  "Supplier Email": "Supplier Email",
  "user name (Sender)": "user name (Sender)",
  "customer": "customer",
  "order weight": "order weight",
  "Shared Document": "Shared Document",
  "Sender Name": "Sender Name",
  "Sharing Count": "Sharing Count",
  "User Email": "User Email",
  "Last Modified": "Last Modified",
  "Rebar Items": "Rebar Items",
  "Net Items": "Net Items",
  "Cage Items": "Cage Items",
  "Loading...": "Loading...",
  "Total Number of Users:": "Total Number of Users:",
  "Send Mail": "Send Mail",
  "search here...": "search here...",
  "Prev": "Prev",
  "Next": "Next",
  "Businesses": "Businesses",
  "Total Number of Businesses:": "Total Number of Businesses:",
  "search businesses...": "search businesses...",
  "Orders": "Orders",
  "Total Number of Orders:": "Total Number of Orders:",
  "Total Order Weights:": "Total Order Weights:",
  "(tons)": "(tons)",
  "search orders...": "search orders...",
  "Suppliers": "Suppliers",
  "email": "email",
  "search email suppliers...": "search email suppliers...",
  "WhatsApp": "WhatsApp",
  "search WhatsApp suppliers...": "search WhatsApp suppliers...",
  "Live Users": "Live Users",
  "connected": "connected",
  "Users active during the last 15 minutes": "Users active during the last 15 minutes",
  "Refresh": "Refresh",
  "No connected users right now": "No connected users right now",
  "Users will appear after activity on the website.": "Users will appear after activity on the website.",
  "Status": "Status",
  "User": "User",
  "Contact": "Contact",
  "Company": "Company",
  "Current page": "Current page",
  "Connected for": "Connected for",
  "Last activity": "Last activity",
  "Online": "Online",
  "ID:": "ID:",
  "The list refreshes automatically every 30 seconds. Users are removed after 15 minutes without activity.": "The list refreshes automatically every 30 seconds. Users are removed after 15 minutes without activity.",
  "Select date": "Select date",
  "Free Trial Start Date": "Free Trial Start Date",
  "Free Trial End Date": "Free Trial End Date",
  "Trial Remaning Days": "Trial Remaning Days",
  "Free Trial Suppliers": "Free Trial Suppliers",
  "Link": "Link",
  "link": "link",
  "Original User": "Original User",
  "Sign Date": "Sign Date",
  "Package": "Package",
  "Free Trial": "Free Trial",
  "Limited": "Limited",
  "Unlimited": "Unlimited",
  "Package Status": "Package Status",
  "Operational": "Operational",
  "Ceased": "Ceased",
  "Printing Count": "Printing Count",
  "Nets Pool": "Nets Pool",
  "Standard Nets": "Standard Nets",
  "Order by Popularity": "Order by Popularity",
  "Edit Text": "Edit Text",
  "add new row": "add new row",
  "cancel": "cancel",
  "save": "save",
  "Steel Type": "Steel Type",
  "Diameter": "Diameter",
  "Select": "Select",
  "Special Nets": "Special Nets",
  "Cage Pool": "Cage Pool",
  "Standard Cage": "Standard Cage",
  "Spiral Steel Type": "Spiral Steel Type",
  "Spiral Wire Diameter": "Spiral Wire Diameter",
  "Length Rebar Steel Type": "Length Rebar Steel Type",
  "Length Rebar Diameter": "Length Rebar Diameter",
  "Quantity of Length Rebars": "Quantity of Length Rebars",
  "Rebars Pool": "Rebars Pool",
  "Standard Rebars": "Standard Rebars",
  "Edit": "Edit",
  "delete": "delete",
  "add new shape": "add new shape",
  "Steel Type & Weights": "Steel Type & Weights",
  "add new steel type": "add new steel type",
  "Enter diameter": "Enter diameter",
  "Add": "Add",
  "Steel Name": "Steel Name",
  "Enter steel type name": "Enter steel type name",
  "rebar diameters": "rebar diameters",
  "Create Bid": "Create Bid",
  "Choose a Supplier": "Choose a Supplier",
  "Select Supplier": "Select Supplier",
  "Loading more...": "Loading more...",
  "Order Number": "Order Number",
  "type order number": "type order number",
  "Fees (apply on all rows)": "Fees (apply on all rows)",
  "Order price before fees:": "Order price before fees:",
  "ILS": "ILS",
  "Standard Deviation": "Standard Deviation",
  "Added:": "Added:",
  "Subtotal:": "Subtotal:",
  "Easybar fee": "Easybar fee",
  "Payment Fee": "Payment Fee",
  "Total after payment fee:": "Total after payment fee:",
  "Total order": "Total order",
  "Choose Pdf Language": "Choose Pdf Language",
  "English": "English",
  "Hebrew": "Hebrew",
  "Prices Pdf": "Prices Pdf",
  "Prices Pdf Preview": "Prices Pdf Preview",
  "Original Pdf": "Original Pdf",
  "Original Pdf Preview": "Original Pdf Preview",
  "Delete Supplier": "Delete Supplier",
  "Suppliers pricing": "Suppliers pricing",
  "Supplier Pricing": "Supplier Pricing",
  "add Supplier": "add Supplier",
  "Supplier Name": "Supplier Name",
  "Enter Supplier Name": "Enter Supplier Name",
  "Cancel": "Cancel",
  "A supplier with this name already Exist!": "A supplier with this name already Exist!",
  "sr": "sr",
  "Polygonal steel": "Polygonal steel",
  "8-25 mm": "8-25 mm",
  "above 25 mm": "above 25 mm",
  "Round steel": "Round steel",
  "6-12 mm": "6-12 mm",
  "above 14 mm": "above 14 mm",
  "Cuts": "Cuts",
  "Bending": "Bending",
  "Extra for": "Extra for",
  "2D hoops": "2D hoops",
  "Standard nets": "Standard nets",
  "Special nets": "Special nets",
  "bending nets": "bending nets",
  "Symmetrical": "Symmetrical",
  "standard pile": "standard pile",
  "cage": "cage",
  "Special Pile": "Special Pile",
  "Gama Pile": "Gama Pile",
  "2 Tzol": "2 Tzol",
  "2.5 Tzol": "2.5 Tzol",
  "PDF (Hebrew)": "PDF (Hebrew)",
  "Yes": "Yes",
  "No": "No",
  "existing": "existing",
  "new": "new",
  "Block Users": "Block Users",
  "Block User": "Block User",
  "Verify Users": "Verify Users",
  "Verify User": "Verify User",
  "Delete Users": "Delete Users",
  "Delete User": "Delete User",
  "Deleting...": "Deleting...",
  "Failed to delete users.": "Failed to delete users.",
  "Failed to verify user.": "Failed to verify user.",
  "Failed to block user.": "Failed to block user.",
  "User verified successfully.": "User verified successfully.",
  "User blocked successfully.": "User blocked successfully.",
  "Are you sure you want to permanently delete this user?": "Are you sure you want to permanently delete this user?",
  "Delete users confirmation": "Are you sure you want to permanently delete {{count}} users?",
  "Users verified": "{{count}} users verified successfully.",
  "Users blocked": "{{count}} users blocked successfully.",
  "In Review": "In Review",
  "Approved": "Approved",
  "Suspended": "Suspended",
  "Could not load connected users.": "Could not load connected users.",
  "Just now": "Just now",
  "Minutes ago": "{{count}} minutes ago",
  "Minutes ago_one": "1 minute ago",
  "Hours and minutes": "{{hours}}h {{minutes}}m",
  "Minutes": "{{count}}m",
  "Under a minute": "< 1m"
};
